module.exports = __webpack_public_path__ + "img/DOGE.2878acda.png";